package com.macrofocus.eflux.ui.layer

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.eflux.network.risk.RiskComponent
import com.macrofocus.eflux.network.risk.RiskComponentPolygon
import deckgl.PolygonLayer
import js.objects.unsafeJso

fun createRiskComponentLayer(
    componentList: Array<RiskComponentPolygon>,
    isCartographicZoomed: Boolean,
    riskMask: Int,
    probing: MutableSingleSelection<RiskComponent>,
    selection: MutableSelection<RiskComponent>

) : PolygonLayer<RiskComponentPolygon> {
    val severe = arrayOf(139, 0, 0)
    val serious = arrayOf(255, 69, 0)
    val warning = arrayOf(255, 215, 0)
    val normal = arrayOf(0, 128, 0)
    val invalid = arrayOf(35, 135, 135)

    return PolygonLayer<RiskComponentPolygon>(unsafeJso {
        id = "risk-component-layer"

        visible = componentList.isNotEmpty()

        this.data = componentList
        opacity = if(isCartographicZoomed) 0.05 else 1.0
        asDynamic().positionFormat = "XY"
        asDynamic().getPolygon = { d: RiskComponentPolygon -> d.deckglPolygon }
        asDynamic().getFillColor = arrayOf(255, 69, 0, 30)
        pickable = probing.isEnabled ||selection.isEnabled
        autoHighlight = true
        highlightColor = if(isCartographicZoomed) arrayOf(255, 215, 0, 32) else arrayOf(255, 215, 0, 127)
        updateTriggers = unsafeJso {
            this.asDynamic().opacity = arrayOf(isCartographicZoomed)
            this.asDynamic().getFillColor = arrayOf(isCartographicZoomed)
            this.asDynamic().highlightColor = arrayOf(isCartographicZoomed)
        }
        onHover = { info ->
            val o = info.`object`
            if (o != null) {
                if (o is RiskComponentPolygon) {
                    val riskId = (o as RiskComponentPolygon).riskComponent
                    probing.selected = riskId
                } else {
                    probing.clearSelection()
                }
            } else {
                probing.clearSelection()
            }
        }
        onClick = { info: dynamic ->
            val o = info.`object`
            if (o != null) {
                if (o is RiskComponentPolygon) {
                    val riskId = (o as RiskComponentPolygon).riskComponent
                    selection.setSelectedElement(riskId)
                } else {
                    selection.clearSelection()
                }
            } else {
                selection.clearSelection()
            }
        }

    })
}
